import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/logo2r.png";
import "./Header.css";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import UGC from "../../assets/UGC.jpg";
import AICTE from "../../assets/AICTE.png";
import ISO from "../../assets/ISO.png";
import { resources } from "../Resourses/Resources";
import axios from "axios";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import List from "@mui/material/List";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import BannerNew from "../../assets/Banner/BannerSaiSpurthiNew.png";
import MobileBanner from "../../assets/Banner/Untitled design (3).png";
import Banner from "../../assets/Banner/Banner10.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getUserInfo } from "../Authservice";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const Header = () => {
   const userRole = getUserInfo()?.roles[0];
   console.log(userRole)
    const isAdmin = userRole === "ROLE_MANAGEMENT";
  const userDetailsCookie = Cookies.get("userDetails");
  const [departMent, setDepartment] = useState("");
  const navigate = useNavigate();
  const [viewFile, setViewFile] = useState(false);
  const [fileToOpen, setFileToOpen] = useState("")
  const [lastInserTedRecord, setLastInsertedRecord] = useState({});
  const [typeOfUload, setTypeOfUpload] = useState("");
  const [role, setRole] = useState("");
  const [examBranchNotifications, setExamBranchNotifications] = useState([])
  const [officeNtifications, setOfficeNotifications] = useState([])



  const handleClickOpen = () => {
    setViewFile(true);
  };

  const handleClose = () => {
    setViewFile(false);
  };
  useEffect(() => {
    if (userDetailsCookie != null && userDetailsCookie != "") {
      const userDetails = JSON.parse(userDetailsCookie);
      const details = userDetails.roles[0];
      setDepartment(details);
      setRole(details);
      if (details === "ROLE_MANAGEMENT") {
        setTypeOfUpload("General");
      } else if (details === "ROLE_EXAMBRANCH") {
        setTypeOfUpload("ExamBranch");
      }
    }
  }, [userDetailsCookie]);
  console.log("department===>", departMent);
  const date = new Date();
  let currentMonth;
  let currentDate;
  const toDaysDate = date.getDate();
  const month = date.getMonth() + 1;
  const currentYear = date.getFullYear();

  if (month < 10) {
    currentMonth = "0" + month;
  } else {
    currentMonth = month;
  }
  if (toDaysDate < 10) {
    currentDate = "0" + toDaysDate;
  } else {
    currentDate = toDaysDate;
  }
  const newDate = currentYear + "-" + currentMonth + "-" + currentDate;

  const fetchExamBranchNotifications = async () => {
    try {
      const details = await axios.get(resources.APPLICATION_URL + `getLastFiveRecords?typeOfUpload=ExamBranch`)
      console.log(" exam branch details====>", details.data)
      if (details?.data?.length > 0) {
        setExamBranchNotifications(details?.data)
      }

    } catch (error) {
      console.log("error", error)
    }
  }

  const fetchOfficeRecords = async () => {
    try {
      const details = await axios.get(resources.APPLICATION_URL + `getLastFiveRecords?typeOfUpload=Office`)
      console.log("office details====>", details.data)
      setOfficeNotifications(details?.data)
    } catch (error) {
      console.log("error==>", error)
    }
  }

  const handleShowSelfDeclarationPdf = async (param) => {
    try {
      const response = await axios.get(
        resources.APPLICATION_URL +
        "filenames?filename=" +
        param +
        "&foldername=ssr"
      );
      console.log("response", response.data);
      const base64 = response.data;

      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      window.open(url, "_blank");
    } catch (e) {
      console.log("error", e);
    }
  };
  console.log("typeOfUload===>", typeOfUload);
  const location = useLocation();
  const fetchLasstRecord = async () => {
    try {
      // if (typeOfUload !== null && typeOfUload !== "") {
        const response = await axios.get(
          resources.APPLICATION_URL +
          `getLastInsertedRecord?typeOfUpload=${typeOfUload}`
        );
        const details = response.data;
        if (details.endDate >= newDate) {
          console.log("triggered");
          console.log("responsee",response.data);
          setLastInsertedRecord(response.data);
        } else {
          console.log("triggered");
        }
      // }
    } catch (error) {
      console.log("error");
    }
  };
  useEffect(() => {
    
    fetchLasstRecord();
    fetchExamBranchNotifications();
    fetchOfficeRecords();
  }, [typeOfUload]);
  const handleLogout = async () => {
    console.log("logout triggered");
    await Cookies.remove("userDetails");
    window.location.reload();
    navigate("/");
  };
  const handleViewFile = async (filedata) => {
    setViewFile(true)
    setFileToOpen(filedata)
  }

  console.log("=========================>>>>>>>>>>>>>>",lastInserTedRecord)
  return (
    <div style={{ width: "100vw", zIndex: 100000 }}>
      <div className="hm_header">
        <div>
          <div className="col-lg-2 col-md-3 col-sm-2 col-xs-12 hidden-xs notMainDiv">
            <div className="notificationBackground">
              <div className="flash-box123">
                <p>Notifications</p>
              </div>
            </div>
          </div>
          <div className="col-sm-12 notification_banner_cnt">
            <marquee behavior="scroll" direction="left" scrollAmount="10">
              <div className="d-flex align-items-center gap-3 notification_bg_cnt">
                <NewReleasesIcon className="heartbeat" sx={{ fontSize: 28 }} />

                {lastInserTedRecord.endDate != null && lastInserTedRecord.endDate !== "" ? (
                  <div style={{ display: "flex" }}>
                    {/* General Notification */}
                    <p
                      className="notification_prg"
                      style={{ cursor: "pointer" }}
                      onClick={() => setViewFile(true)}
                    >
                      {lastInserTedRecord?.description}
                    </p>
                    {examBranchNotifications[0] && (
                          <div
                            style={{ cursor: "pointer", marginLeft: "40px" }}
                            onClick={() => handleViewFile(examBranchNotifications[0].filePath)}
                          >
                            <p className="notification_prg">
                              <a href="#"><NewReleasesIcon />{examBranchNotifications[0]?.description}</a>
                            </p>
                          </div>
                        )}

                        {/* Office Notification */}
                        {officeNtifications[0] && (
                          <div
                            style={{ cursor: "pointer", marginLeft: "40px" }}
                            onClick={() => handleViewFile(officeNtifications[0].filePath)}
                          >
                            <p className="notification_prg" style={{ color: "orangered" }}>
                              <a href="#"><NewReleasesIcon />{officeNtifications[0]?.description}</a>
                            </p>
                          </div>
                        )}

                    {/* Display only if admin */}
                    {isAdmin && (
                      <>
                        {/* Exam Notification */}
                        
                      </>
                    )}
                  </div>
                ) : (
                  <p style={{ paddingTop: "11px" }}>
                    {/* Welcome to Saispurthi New Notification Board */}
                  </p>
                )}
              </div>
            </marquee>
          </div>

        </div>
        <img src={Banner} alt="Banner Sai Spurthi" className="sai_banner_img" />
      </div>
      <div>
        <nav className="manu_bar menubar navbar navbar-expand-md navbar-light p-0">
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="menu_inner navbar-nav p-4 p-lg-0">
              <div className="nav-item">
                <Link
                  to="/"
                  className={
                    location.pathname === "/"
                      ? "nav-item nav-link active"
                      : "nav-item nav-link"
                  }
                  style={{ marginRight: "30px", fontWeight: "bold" }}
                >
                  Home
                </Link>
              </div>
              {/* ABOUT  */}
              <div className="nav-item">
                <Link to="#" className="nav-link" data-bs-toggle="dropdown" style={{ fontWeight: "bold" }}>
                  About <KeyboardArrowDownIcon />
                </Link>
                <div
                  className="dropdown-menu fade-down m-0"
                  style={{ padding: "10px", lineHeight: "30px" }}
                >
                  <Link
                    to="/Administration/management"
                    className={
                      location.pathname === "/Administration/management"
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    style={{ paddingLeft: "5px", fontWeight: "bold", }}
                  >
                    Management
                  </Link>
                  <Link
                    to="/Administration/society"
                    className={
                      location.pathname === "/Administration/society"
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    style={{ paddingLeft: "5px", fontWeight: "bold" }}
                  >
                    Society
                  </Link>
                  <Link
                    to="/Administration/vision"
                    className={
                      location.pathname === "/Administration/vision"
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    style={{ paddingLeft: "5px", fontWeight: "bold" }}
                  >
                    Vision & Mission
                  </Link>
                  <Link
                    to="/Administration/quality"
                    className={
                      location.pathname === "/Administration/quality"
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    style={{ paddingLeft: "5px", fontWeight: "bold" }}
                  >
                    Quality policy
                  </Link>
                  <Link
                    to="/Administration/governing"
                    className={
                      location.pathname === "/Administration/governing"
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    style={{ paddingLeft: "5px", fontWeight: "bold" }}
                  >
                    Governing Body
                  </Link>
                  <Link
                    to="/Administration/principal"
                    className={
                      location.pathname === "/Administration/principal"
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    style={{ paddingLeft: "5px", fontWeight: "bold" }}
                  >
                    Principal
                  </Link>
                  <Link
                    to="/Administration/council"
                    className={
                      location.pathname === "/Administration/council"
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    style={{ paddingLeft: "5px", fontWeight: "bold" }}
                  >
                    Academic Council
                  </Link>
                </div>
              </div>
              {/* ACADEMICS */}
              <div className="nav-item">
                <Link to="#" className="nav-link" data-bs-toggle="dropdown" style={{ fontWeight: "bold" }}>
                  Academics <KeyboardArrowDownIcon />
                </Link>
                <div
                  className="dropdown-menu fade-down m-0 multi-column-dropdown"
                  style={{
                    display: "flex",
                    gap: "20px",
                    padding: "10px",
                    fontWeight: "bold",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    className="dropdown-column"
                    style={{
                      borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">Academics</h6>
                    <Link
                      to="/acadamics/acadamicRegulations"
                      className={
                        location.pathname === "/acadamics/acadamicRegulations"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "0", fontWeight: "bold", paddingLeft: "5px" }}
                    >
                      Academic Regulations
                    </Link>
                    <Link
                      to="/acadamics/acadamicCalender"
                      className={
                        location.pathname === "/acadamics/acadamicCalender"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "0", fontWeight: "bold", paddingLeft: "5px" }}
                    >
                      Academic Calender
                    </Link>
                    <Link
                      to="/acadamics/incentives"
                      className={
                        location.pathname === "/acadamics/incentives"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ fontWeight: "bold", paddingLeft: "5px" }}
                    >
                      Incentives
                    </Link>
                    <Link
                      to="/Awards"
                      className={
                        location.pathname === "/Awards"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Awards & Recognitions
                    </Link>
                    <Link
                      to="/governance/committee"
                      className={
                        location.pathname === "/governance/committee"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                     Committees
                    </Link>
                    <Link
                      to="/Administration/mandatory"
                      className={
                        location.pathname === "/Administration/mandatory"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Approvals
                    </Link>

                    {/* <Link
                      to="/acadamics/socialService"
                      className={
                        location.pathname === "/acadamics/socialService"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "0", fontWeight: "bold" }}
                    >
                      Social Service
                    </Link> */}
                  </div>

                  <div
                    className="dropdown-column"
                    style={{
                      borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">Departments</h6>
                    <Link
                      to="/departments/cse"
                      className={
                        location.pathname === "/departments/cse"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      CSE
                    </Link>
                    <Link
                      to="/departments/ece"
                      className={
                        location.pathname === "/departments/ece"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      ECE
                    </Link>
                    <Link
                      to="/departments/eee"
                      className={
                        location.pathname === "/departments/eee"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      EEE
                    </Link>
                    <Link
                      to="/departments/ai&ds"
                      className={
                        location.pathname === "/departments/ai&ds"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      AI & DS
                    </Link>
                    <Link
                      to="/departments/aiml"
                      className={
                        location.pathname === "/departments/aiml"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      AIML
                    </Link>
                    <Link
                      to="/departments/mech"
                      className={
                        location.pathname === "/departments/mech"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      MECH
                    </Link>
                    <Link
                      to="/departments/s&h"
                      className={
                        location.pathname === "/departments/s&h"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      S&H
                    </Link>
                    <Link
                      to="/departments/mba"
                      className={
                        location.pathname === "/departments/mba"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      MBA
                    </Link>
                    <Link
                      to="/departments/polytechnic"
                      className={
                        location.pathname === "/departments/polytechnic"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Polytechnic
                    </Link>
                  </div>

                  <div className="dropdown-column">
                    <h6 className="dropdown-menu-heading">Placements</h6>
                    <Link
                      to="/placements/placementRecords"
                      className="dropdown-item"
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Placement Records
                    </Link>
                    <Link
                      to="/placements/companies"
                      className={
                        location.pathname === "/placements/companies"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Companies
                    </Link>
                  </div>
                </div>
              </div>
              {/* ADMISSIONS AND ACREDATIONS */}
              <div className="nav-item">
                <Link to="#" className="nav-link" data-bs-toggle="dropdown" style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Admissions & Acredations <KeyboardArrowDownIcon />
                </Link>
                <div
                  className="dropdown-menu fade-down m-0 multi-column-dropdown"
                  style={{
                    display: "flex",
                    gap: "20px",
                    padding: "10px",
                    fontWeight: "bold",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    className="dropdown-column"
                    style={{
                      borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">Admissions</h6>
                    <Link
                      to="/admissions/procedure"
                      className={
                        location.pathname === "/admissions/procedure"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Admission Procedure
                    </Link>
                    <Link
                      to="/admissions/fee"
                      className={
                        location.pathname === "/admissions/fee"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Fee Structure
                    </Link>
                    <Link
                      to="/admissions/form"
                      className={
                        location.pathname === "/admissions/form"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Admission Form
                    </Link>
                    <Link
                      to="/feedback/enqiryform"
                      className={
                        location.pathname === "/feedback/enqiryform"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Contact For Admission
                    </Link>
                  </div>

                  <div
                    className="dropdown-column"
                    style={{
                      borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">NAAC</h6>


                    <Link
                      to="/naac/iqac"
                      className={
                        location.pathname === "/naac/iqac"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      IQAC
                    </Link>

                    <Link
                      onClick={() => {
                        handleShowSelfDeclarationPdf("iiqareport.pdf");
                      }}
                      className="dropdown-item"
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      IIQA Report
                    </Link>


                    <Link
                      to="/naac/naacSsr"
                      className={
                        location.pathname === "/naac/naacSsr"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      SSR
                    </Link>
                    <Link
                      to="/naac/naacDvv"
                      className={
                        location.pathname === "/naac/naacDvv"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      DVV
                    </Link>
                    {/* <Link
                      to="/naac/aqar-2023-2024"
                      className={
                        location.pathname === "/naac/aqar-2023-2024"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Aqar 2023-2024
                    </Link> */}


                    {/* <Link
                      onClick={() => {
                        handleShowSelfDeclarationPdf("selfdeclaration");
                      }}
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                      className={
                        location.pathname === "/naac/iqac"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                    >
                      Self Declaration
                    </Link> */}

                    {/* <Link
                      onClick={() => {
                        handleShowSelfDeclarationPdf("undertaking.pdf");
                      }}
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                      className="dropdown-item"
                    >
                      Undertaking
                    </Link> */}


                  </div>

                  <div className="dropdown-column">
                    <h6 className="dropdown-menu-heading">NIRF</h6>
                    <Link
                      className="dropdown-item"
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                      onClick={() => {
                        handleShowSelfDeclarationPdf("overall.pdf");
                      }}
                    >
                      OverAll
                    </Link>

                    <Link
                      className="dropdown-item"
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                      onClick={() => {
                        handleShowSelfDeclarationPdf("engineering.pdf");
                      }}
                    >
                      Engineering
                    </Link>
                    <Link
                      className="dropdown-item"
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                      onClick={() => {
                        handleShowSelfDeclarationPdf("management.pdf");
                      }}
                    >
                      NIRF - Management
                    </Link>
                  </div>
                </div>
              </div>
              {/* EXAMINATIONS */}
              <div className="nav-item">
                <Link to="#" className="nav-link" data-bs-toggle="dropdown" style={{ fontWeight: "bold" }}>
                  Examinations <KeyboardArrowDownIcon />
                </Link>
                <div
                  className="dropdown-menu fade-down m-0 multi-column-dropdown"
                  style={{
                    display: "flex",
                    gap: "20px",
                    padding: "10px",
                    fontWeight: "bold",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    className="dropdown-column"
                    style={{
                      borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">Autonomous</h6>
                    <Link
                      to="/acadamics/COE"
                      className={
                        location.pathname === "/acadamics/COE"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      COE
                    </Link>
                    <Link
                      to="/acadamics/acadamicNotice"
                      className={
                        location.pathname === "/acadamics/acadamicNotice"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Notices
                    </Link>
                    <Link
                      to="/acadamics/acadamicRegulations"
                      className={
                        location.pathname === "/acadamics/acadamicRegulations"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Academic Regulations
                    </Link>
                    <Link
                      to="/acadamics/acadamicCalender"
                      className={
                        location.pathname === "/acadamics/acadamicCalender"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Academic Calender
                    </Link>
                    <Link
                      to="/SyllabusMenu"
                      className={
                        location.pathname === "/SyllabusMenu"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Syllabus
                    </Link>
                    <Link
                      to="/acadamics/TIMETABLES"
                      className={
                        location.pathname === "/acadamics/TIMETABLES"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Time Tables
                    </Link>
                    <Link
                      to="/acadamics/RESULTS"
                      className={
                        location.pathname === "/acadamics/RESULTS"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Results
                    </Link>
                    <Link
                      to="/acadamics/EXAMINATION"
                      className={
                        location.pathname === "/acadamics/EXAMINATION"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Examination Portal
                    </Link>
                    <Link
                      to="/acadamics/MALPRACTICE"
                      className={
                        location.pathname === "/acadamics/MALPRACTICE"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Malpractice Guidelines
                    </Link>
                  </div>

                  <div
                    className="dropdown-column"
                    style={{
                      // borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">JNTUH</h6>
                    <Link
                      to="/departments/cse"
                      className={
                        location.pathname === "/departments/cse"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Circulars
                    </Link>
                    <Link
                      to="/SyllabusMenu"
                      className={
                        location.pathname === "/SyllabusMenu"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Syllabus
                    </Link>
                    <Link
                      to="/departments/eee"
                      className={
                        location.pathname === "/departments/eee"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Time Tables
                    </Link>
                    <Link
                      to="/Results"
                      className={
                        location.pathname === "/Results"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{ paddingLeft: "5px", fontWeight: "bold" }}
                    >
                      Results
                    </Link>
                  </div>
                </div>
              </div>
              {/* 6.CAMPUS */}
              <div className="nav-item">
                <Link to="#" className="nav-link" data-bs-toggle="dropdown" style={{ fontWeight: "bold" }}>
                  Campus <KeyboardArrowDownIcon />
                </Link>
                <div
                  className="dropdown-menu fade-down m-0 multi-column-dropdown"
                  style={{
                    display: "flex",
                    gap: "20px",
                    padding: "10px",
                    fontWeight: "bold",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <div
                    className="dropdown-column"
                    style={{
                      borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading" style={{ textAlign: "center" }}>Amenities</h6>
                    <div style={{
                      display: "flex", gap: "20px",
                      padding: "10px",
                    }}>
                      <div>
                        <Link
                          to="/amenities/library"
                          className={
                            location.pathname === "/amenities/library"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Library
                        </Link>
                        <Link
                          to="/amenities/digitalLibrary"
                          className={
                            location.pathname === "/amenities/digitalLibrary"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Digital Library
                        </Link>

                        <Link
                          to="/amenities/englishLabs"
                          className={
                            location.pathname === "/amenities/englishLabs"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          English lab
                        </Link>


                        <Link
                          to="/amenities/seminarHalls"
                          className={
                            location.pathname === "/amenities/seminarHalls"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Seminar Halls
                        </Link>
                        <Link
                          to="/amenities/hostels"
                          className={
                            location.pathname === "/amenities/hostels"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Hostels
                        </Link>
                        <Link
                          to="/amenities/cafeteria"
                          className={
                            location.pathname === "/amenities/cafeteria"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Cafeteria
                        </Link>
                        <Link
                          to="/amenities/e-classRooms"
                          className={
                            location.pathname === "/amenities/e-classRooms"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          E-Class Rooms
                        </Link>
                        <Link
                          to="/amenities/staffQuarters"
                          className={
                            location.pathname === "/amenities/staffQuarters"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Staff Quarters
                        </Link>
                        <Link
                          to="/amenities/temple"
                          className={
                            location.pathname === "/amenities/temple"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Temple In College
                        </Link>


                      </div>

                      <div>
                        <Link
                          to="/amenities/internet"
                          className={
                            location.pathname === "/amenities/internet"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Internet
                        </Link>
                        <Link
                          to="/amenities/ictFecilities"
                          className={
                            location.pathname === "/amenities/ictFecilities"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          ICT Fecilities
                        </Link>
                        <Link
                          to="/amenities/sports"
                          className={
                            location.pathname === "/amenities/sports"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Sports & Games
                        </Link>

                        <Link
                          to="/amenities/transport"
                          className={
                            location.pathname === "/amenities/transport"
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Transportation
                        </Link>


                      </div>
                    </div>
                  </div>

                  <div
                    className="dropdown-column"
                    style={{
                      // borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">Gallery</h6>
                    <Link
                      to="/gallery/campusPhotos"
                      className={
                        location.pathname === "/gallery/campusPhotos"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Campus Photos
                    </Link>

                    {/* {role === "ROLE_MANAGEMENT" && (
                      <Link
                        to="/gallery/photosUpload"
                        className={
                          location.pathname === "/gallery/photosUpload"
                            ? "dropdown-item active"
                            : "dropdown-item"
                        }
                        style={{
                          paddingLeft: "5px",
                          fontWeight: "bold",
                          lineHeight: "30px",
                        }}
                      >
                        PHOTOS UPLOAD
                      </Link>
                    )} */}
                  </div>
                </div>
              </div>
              {/* 7.STUDENT CORNER */}
              <div className="nav-item">
                <Link to="#" className="nav-link" data-bs-toggle="dropdown" style={{ fontWeight: "bold" }}>
                  Student Corner <KeyboardArrowDownIcon />
                </Link>
                <div
                  className="dropdown-menu fade-down m-0 multi-column-dropdown"
                  style={{
                    display: "flex",
                    gap: "20px",
                    padding: "10px",
                    fontWeight: "bold",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                    right: "120px",
                  }}
                >
                  <div
                    className="dropdown-column"
                    style={{
                      borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">Student Corner</h6>
                    <button
                      style={{
                        borderWidth: "0px",
                        backgroundColor: "transparent",
                        paddingLeft: "0px",
                        fontWeight: "bold",
                      }}
                    >
                      {/* <Link
                        className="dropdown-item"
                        onClick={() => {
                          handleShowSelfDeclarationPdf("inv_23_24.pdf");
                        }}
                        style={{
                          paddingLeft: "5px",
                          fontWeight: "bold",
                          lineHeight: "30px",
                        }}
                      >
                        Student scholarship Notification-AY:23-24
                      </Link> */}
                    </button>

                    <Link
                      to="/StudentCorner/Scholarship"
                      className={
                        location.pathname === "/StudentCorner/Scholarship"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Scholarship
                    </Link>
                    <Link
                      to="/StudentCorner/Clubs"
                      className={
                        location.pathname === "/StudentCorner/Clubs"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Clubs
                    </Link>
                    <Link
                      to="/student/socialService"
                      className={
                        location.pathname === "/student/socialService"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      NSS
                    </Link>
                  </div>
                  <div
                    className="dropdown-column"
                    style={{
                      borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">Alumini</h6>
                    <button
                      style={{
                        borderWidth: "0px",
                        backgroundColor: "transparent",
                        paddingLeft: "0px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      <Link
                        className="dropdown-item"
                        style={{
                          paddingLeft: "5px",
                          fontWeight: "bold",
                          lineHeight: "30px",
                        }}
                        onClick={() => {
                          handleShowSelfDeclarationPdf("inv_21_22.pdf");
                        }}
                      >
                        Invitation -AY:21-22
                      </Link>
                    </button>
                    <Link
                      to="/alumini/registration"
                      className={
                        location.pathname === "/alumini/registration"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Alumini Registration
                    </Link>
                    <Link
                      to="/alumini/view"
                      className={
                        location.pathname === "/alumini/view"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      View Students
                    </Link>
                  </div>

                  <div
                    className="dropdown-column"
                    style={{
                      // borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                    }}
                  >
                    <h6 className="dropdown-menu-heading">Greviences</h6>
                    {/* <Link
                      to="/feedback/enqiryform"
                      className={
                        location.pathname === "/feedback/enqiryform"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "0px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Enquiry Form
                    </Link> */}
                    <Link
                      to="/feedback/greivences"
                      className={
                        location.pathname === "/feedback/greivences"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Grevience Form
                    </Link>
                    <Link
                      to="/feedback/ic-committee"
                      className={
                        location.pathname === "/feedback/ic-committee"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      IC Committee
                    </Link>
                    <Link
                      to="/feedback/aicteFeedback"
                      className={
                        location.pathname === "/feedback/aicteFeedback"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Aicte Feedback
                    </Link>

                    <Link
                      to="/feedback/teacherFeedback"
                      className={
                        location.pathname === "/feedback/teacherFeedback"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Teacher Feedback
                    </Link>
                    <Link
                      to="/feedback/studentFeedback"
                      className={
                        location.pathname === "/feedback/studentFeedback"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Student Feedback
                    </Link>
                    <Link
                      to="/feedback/employerFeedback"
                      className={
                        location.pathname === "/feedback/employerFeedback"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Employer Feedback
                    </Link>
                    <Link
                      to="/feedback/aluminiFeedback"
                      className={
                        location.pathname === "/feedback/aluminiFeedback"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Alumini Feedback
                    </Link>
                  </div>
                </div>
              </div>
              {/* QUICK LINKS */}

              <div className="nav-item">
                <Link to="#" className="nav-link" data-bs-toggle="dropdown" style={{ fontWeight: "bold" }}>
                  Quick Links <KeyboardArrowDownIcon />
                </Link>
                <div
                  className="dropdown-menu fade-down m-0"
                  style={{
                    padding: "10px",
                    lineHeight: "30px",
                    display: "flex",
                    right: "120px",
                  }} // Ensures side-by-side layout
                >
                  {/* Column 1: Autonomous */}
                  <div
                    className="dropdown-column"
                    style={{
                      borderRight: "1px solid #9f9d9d",
                      padding: "10px",
                      minWidth: "250px", // Adjust as needed
                    }}
                  >
                    <h6 className="dropdown-menu-heading">Quick Links</h6>
                    <Link
                      to="/Administration/strength"
                      className={`dropdown-item ${location.pathname === "/Administration/strength"
                        ? "active"
                        : ""
                        }`}
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Strengths
                    </Link>
                    {/* <Link
                      to="/Administration/mandatory"
                      className={`dropdown-item ${
                        location.pathname === "/Administration/mandatory"
                          ? "active"
                          : ""
                      }`}
                      style={{
                        paddingLeft: "0px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Mandatory Disclosure
                    </Link> */}
                    <Link
                      to="/acadamics/socialService"
                      className={`dropdown-item ${location.pathname === "/acadamics/socialService"
                        ? "active"
                        : ""
                        }`}
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Social Service
                    </Link>
                    <Link
                      to="/acadamics/incentives"
                      className={`dropdown-item ${location.pathname === "/acadamics/incentives"
                        ? "active"
                        : ""
                        }`}
                      style={{
                        paddingLeft: "5px",
                        fontWeight: "bold",
                        lineHeight: "30px",
                      }}
                    >
                      Incentives
                    </Link>
                    {role === "ROLE_MANAGEMENT" ? (
                      <Link
                        onClick={() => handleLogout()}
                        className={
                          location.pathname === "/contactus"
                            ? "nav-item nav-link active"
                            : "nav-item nav-link"
                        }
                        style={{
                          paddingLeft: "5px",
                          fontWeight: "bold",
                          lineHeight: "30px",
                          color: "black", // always black
                        }}
                      >
                        {role ? "LogOut" : "Login"}
                      </Link>
                    ) : (
                      <Link
                        to="/gallery/login"
                        className={
                          location.pathname === "/gallery/Register"
                            ? "nav-item nav-link active"
                            : "nav-item nav-link"
                        }
                        style={{
                          paddingLeft: "5px",
                          fontWeight: "bold",
                          lineHeight: "30px",
                          color: "black", // always black
                        }}
                      >
                        {location.pathname === "/gallery/Register"
                          ? "Login"
                          : location.pathname === "/gallery/login"
                            ? "LogOut"
                            : "Login"}
                      </Link>
                    )}

                    {/* {role === "ROLE_MANAGEMENT" && (
                      <Link
                        to="/gallery/Register"
                        className={
                          location.pathname === "/gallery/Register"
                            ? "nav-item nav-link active"
                            : "nav-item nav-link"
                        }
                        style={{
                          paddingLeft: "5px",
                          fontWeight: "bold",
                          lineHeight: "30px",
                          color: "black", // always black
                        }}
                      >
                        Register
                      </Link>
                    )} */}

                  </div>

                  {/* Column 2: General */}
                  <div
                    className="dropdown-column"
                    style={{ padding: "10px", minWidth: "250px" }} // Ensures it aligns next to "Autonomous"
                  >
                    {role === "ROLE_MANAGEMENT" && role !== "" && (
                      <>
                        <h6 className="dropdown-menu-heading">General</h6>
                        <Link
                          to="/gallery/General/notifications"
                          className={`dropdown-item ${location.pathname ===
                            "/gallery/General/notifications"
                            ? "active"
                            : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          General Notifications
                        </Link>
                        <Link
                          to="/gallery/View/General/Photoupload"
                          className={`dropdown-item ${location.pathname ===
                            "/gallery/View/General/Photoupload"
                            ? "active"
                            : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Photoupload
                        </Link>
                        <Link
                          to="/gallery/View/General/EnquiryForm"
                          className={`dropdown-item ${location.pathname ===
                            "/gallery/View/General/EnquiryForm"
                            ? "active"
                            : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Enquiry Form
                        </Link>
                        <Link
                          to="/admin/feeStructure"
                          className={`dropdown-item ${location.pathname === "/admin/feeStructure"
                            ? "active"
                            : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Fee Structure Add
                        </Link>
                        <Link
                          to="/gallery/View/General/view/enquiryForm"
                          className={`dropdown-item ${location.pathname ===
                            "/gallery/View/General/view/enquiryForm"
                            ? "active"
                            : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          View Enquiry Form
                        </Link>
                        <Link
                          to="/gallery/View/General/courseUpload"
                          className={`dropdown-item ${location.pathname ===
                            "/gallery/View/General/courseUpload"
                            ? "active"
                            : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Course Upload
                        </Link>
                        <Link
                          to="/gallery/View/General/carousel/photosUpload"
                          className={`dropdown-item ${location.pathname === "" ? "active" : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Carousel & Lab Images Upload
                        </Link>
                        <Link
                          to="/feedback/ViewFeedback"
                          className={`dropdown-item ${location.pathname === "/feedback/ViewFeedback"
                            ? "active"
                            : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          View Feedbacks
                        </Link>
                        <Link
                          to="/gallery/View/General/uploadExcelFiles"
                          className={`dropdown-item ${location.pathname ===
                            "/gallery/View/General/uploadExcelFiles"
                            ? "active"
                            : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          Upload Excel Files
                        </Link>
                        <Link
                          to="/gallery/View/General/notifications"
                          className={`dropdown-item ${location.pathname ===
                            "/gallery/View/General/notifications"
                            ? "active"
                            : ""
                            }`}
                          style={{
                            paddingLeft: "5px",
                            fontWeight: "bold",
                            lineHeight: "30px",
                          }}
                        >
                          View General Notifications
                        </Link>

                        {departMent === "ROLE_ADMIN" && (
                          <Link
                            to="/gallery/Register"
                            className={`dropdown-item ${location.pathname === "/gallery/Register"
                              ? "active"
                              : ""
                              }`}
                            style={{
                              paddingLeft: "5px",
                              fontWeight: "bold",
                              lineHeight: "30px",
                              color: "black",

                            }}
                          >
                            Register
                          </Link>
                        )}
                        {departMent === "ROLE_ADMIN" && (
                          <Link
                            to="/feedback/aicteFeedbackView"
                            className={`dropdown-item ${location.pathname ===
                              "/feedback/aicteFeedbackView"
                              ? "active"
                              : ""
                              }`}
                            style={{
                              paddingLeft: "0px",
                              fontWeight: "bold",
                              lineHeight: "30px",
                            }}
                          >
                            AICTE FEEDBACK VIEW
                          </Link>
                        )}
                        {departMent === "ROLE_ADMIN" && (
                          <Link
                            to="/admin/DashboardView"
                            className={`dropdown-item ${location.pathname === "/admin/DashboardView"
                              ? "active"
                              : ""
                              }`}
                            style={{
                              paddingLeft: "0px",
                              fontWeight: "bold",
                              lineHeight: "30px",
                            }}
                          >
                            Dashboard View
                          </Link>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>

              {/* CONTACT US */}
              <div className="nav-item">
                <Link
                  to="/contactus"
                  className="nav-link"
                  data-bs-toggle="dropdown"
                  style={{ fontWeight: "bold" }}
                >
                  Contact Us
                  {/* <KeyboardArrowDownIcon /> */}
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <React.Fragment>
        <Dialog
          fullScreen
          open={viewFile}
          onClose={handleClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              width: "100%",
              height: "100%",
              margin: 0,
              padding: 0,
              maxHeight: "100vh",
            },
          }}
        >
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          {lastInserTedRecord && (
            <iframe
              src={`data:application/pdf;base64,${lastInserTedRecord.filePath}`}
              width="100%"
              height="100%"
            />
          )}
        </Dialog>
      </React.Fragment>
    </div>
  );
};

export default Header;
